import "./sidebar.scss";
import React, { useEffect, useState } from "react";

import exIcon from "../../assets/icons/exchange.png";

const Sidebar = ({ showSidebar, setShowSidebar, currencies }) => {
  const [amount, setAmount] = useState(0);
  const [fromCurrency, setFromCurrency] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [conversionResult, setConversionResult] = useState(0);

  useEffect(() => {
    // console.log(window.screen.width);
    if (currencies && currencies.length > 0) {
      setFromCurrency(currencies[0].currency.name);
      setToCurrency(currencies[0].currency.name);
    }
  }, [currencies]);

  // Conversion algorithm
  const convertCurrency = () => {
    const fromCurrencyRate = currencies.find(
      (currency) => currency.currency.name === fromCurrency
    )?.sellPrice;
    const toCurrencyRate = currencies.find(
      (currency) => currency.currency.name === toCurrency
    )?.sellPrice;

    if (fromCurrencyRate && toCurrencyRate) {
      const result = (amount / toCurrencyRate) * fromCurrencyRate;
      setConversionResult(result.toFixed(2)); // Round to two decimal places
    } else {
      // Handle error if currency rates are not available
    }
  };

  return (
    <div className={`menu`}>
      <button
        className={`exchange-btn z-50 items-center cursor-pointer right-0 top-[26em] ${
          showSidebar
            ? "transition duration-1000 ease-in-out translate-x-[-260%] fixed "
            : "transition duration-1000 ease-in-out translate-x-[-0%] fixed "
        }`}
        onClick={() => setShowSidebar(!showSidebar)}
      >
        مبــدل
        <div className="exchange-i">
          ارز
          <img src={exIcon} alt="exchange" />
        </div>
      </button>
      <div
        className={`convert-container shadow top-[14em] right-0 w-[12rem]  bg-[#d2ae6d] text-white fixed z-40 ${
          showSidebar
            ? "transition duration-1000 ease-in-out translate-x-0"
            : "transition duration-1000 ease-in-out translate-x-full"
        }`}
      >
        {/* <button
          className={`flex text-3xl items-center cursor-pointer z-50
            sm:top-1 ${
              showSidebar
                ? "transition duration-1000 ease-in-out -translate-x-[90%] fixed "
                : "transition duration-1000 ease-in-out translate-x-0 fixed "
            }`}
          onClick={() => setShowSidebar(!showSidebar)}
        >
          <img
            className=" w-5 h-5 my-3    
            "
            width={16}
            height={16}
            src={cancelIcon}
            alt="cancelIcon"
          />
        </button> */}
        <div className="currency-converter">
          <label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </label>
          <label>
            X
            <select
              value={fromCurrency}
              onChange={(e) => setFromCurrency(e.target.value)}
            >
              <option disabled hidden value="">
                از ارز
              </option>
              {currencies.map((currency) => (
                <option
                  key={currency.currency.name}
                  value={currency.currency.name}
                >
                  {currency.currency.name}
                </option>
              ))}
            </select>
          </label>
          <label>
            <img src={exIcon} alt="exchange" />

            <select
              value={toCurrency}
              onChange={(e) => setToCurrency(e.target.value)}
            >
              <option disabled hidden value="">
                به ارز
              </option>
              {currencies.map((currency) => (
                <option
                  key={currency.currency.name}
                  value={currency.currency.name}
                >
                  {currency.currency.name}
                </option>
              ))}
            </select>
          </label>
          <label>
            =<p>{conversionResult}</p>
          </label>
          <button onClick={convertCurrency}>تبـدیـل</button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
